module.exports = __webpack_public_path__ + "img/星火海报1920-960.29aea429.jpg";